const a = async (e, t, o) => e ? fetch((t || "https://hamrahi.cloud/live/api/v1/live/details/vod/{token}").replace("{token}", e), {
  method: "GET",
  signal: o
}).then((r) => r.json()) : Promise.reject("tokenIsEmpty");
export {
  a as default
};
